import React from 'react';

const features = [
  {
    img: 'images/Water.svg',
    size : {
      width : 100,
      height : 100,
    },
    title: 'Unmatched Hydration',
    description: 'Retains moisture on your skin to prevent dryness, giving you soft, glowing skin all day.',
  },
  {
    img: 'images/Clean.svg',
     size : {
      width : 100,
      height : 100,
    },
    title: 'Gentle, Pure Formula',
    description: 'FREE from parabens, phthalates, and dyes, it\'s safe for your sensitive skin and suitable for everyday use.',
  },
  {
    img: 'images/Babys Room.svg',
     size : {
      width : 100,
      height : 100,
    },
    title: 'Versatile for All Ages',
    description: 'Not just for adults—this product is perfect for babies too, providing gentle care for soft, smooth skin.',
  },
  {
    img: 'images/Leaf.svg',
     size : {
      width : 100,
      height : 100,
    },
    title: '100% Natural Ingredients',
    description: 'Made with pure, plant-based ingredients to nourish and protect your skin, free from synthetic chemicals and artificial additives.',
  },
  {
    img: 'images/Year of Dog.svg',
     size : {
      width : 100,
      height : 100,
    },
    title: 'Vegan & Cruelty-Free',
    description: 'Kind to animals and kind to you. Our formula contains no animal-derived ingredients and is never tested on animals.',
  },
  {
    img: 'images/Approval.svg',
     size : {
      width : 100,
      height : 100,
    },
    title: 'Dermatologist Tested & Approved',
    description: 'Carefully tested by skin experts to ensure safe, gentle care that’s perfect for even the most sensitive skin.',
  },
];

const WhyChoose = () => {
  return (
    <section className="why-choose">
      <div className="container-xl">
        <div className="row">
          <div className="col-12">
            <div className="heading-area">
              <h2>See What <span>200k+ Happy Freaks</span> Out there Are Saying</h2>
            </div>
          </div>
        </div>
        <div className="row">
          {features.map((feature, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
              <div className="img-box">
                <img loading='lazy' decoding='async' src={feature.img} alt="icon" width={feature.size.width} height={feature.size.height} />
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col-12">
            <div className="btn-box">
              <a className="button why-ch" href="#prosec">Order Now</a>
              <p>
                <img loading='lazy' decoding='async' src="images/Free-Shipping.png" className='img-fluid' width="75" height="72" alt="safe icon" />
                Free Shipping (3-5 day Delivery)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
